import { apiSlice } from '../../api-slice';

export const unitApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createUnit: builder.mutation({
      query: (data) => ({
        url: 'unit',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Unit'],
    }),
    updateUnit: builder.mutation({
      query: (data) => ({
        url: `unit/${data.id}`,
        method: 'PUT',
        body: {
          name: data.name,
          quantity: data.quantity,
          strip_quantity: data.strip_quantity,
        },
      }),
      invalidatesTags: ['Unit'],
    }),
    deleteUnit: builder.mutation({
      query: (id) => ({
        url: `unit/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Unit'],
    }),
    getUnits: builder.query({
      query: (params) => ({
        url: `unit`,
        method: 'GET',
        params,
      }),
      providesTags: ['Unit'],
      keepUnusedDataFor: 600,
    }),
  }),
});

export const {
  useCreateUnitMutation,
  useGetUnitsQuery,
  useUpdateUnitMutation,
  useDeleteUnitMutation,
} = unitApi;
